module.exports = __webpack_public_path__ + "img/style1_5468c179f.png";